import React, { memo, useMemo } from 'react';
import FabButton from 'global/react-mui/atoms/FabButton';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { partnerListIsOpenSelector } from '../../../store/modules/ui/selectors';
import { uiSliceActions } from '../../../store/modules/ui/reducer';
import { useStyles } from './styles';

const PartnerListToggler = (): JSX.Element => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const isPartnerListDrawerVisible = useSelector(partnerListIsOpenSelector);
	const showPartnerListDrawer = (isOpen) => dispatch(uiSliceActions.setIsPartnerListDrawerOpen({ isOpen }));

	const svgIconProps = { style: { width: 16, height: 16 }, viewBox: '0 0 24 24' };

	return (
		<FabButton
			onClick={() => showPartnerListDrawer(!isPartnerListDrawerVisible)}
			ariaLabel="show map full width"
			icon={isPartnerListDrawerVisible ? 'fullScreen' : 'list'}
			title="show full width map"
			svgIconProps={svgIconProps}
			className={classes.showPartnerListDrawer}
		/>
	);
};

export default memo(PartnerListToggler);
